'use es6';

import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ExitDeveloperModeButton = () => {
  const location = window.location.href;
  const newLocation = location.replace('developerMode=true', '');
  return /*#__PURE__*/_jsx(Button, {
    use: "tertiary-light",
    href: newLocation,
    size: 'small',
    "data-test-id": "exit-developer-mode-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'header.devMode.exit'
    })
  });
};
export default ExitDeveloperModeButton;